<template>
  <b-card :header="title" header-bg-variant="white" header-class="custom-card__header" style="background-color: white;">
    <Pulse v-if="loading" />
    <div v-else class="stacked-bar-chart-widget">
      <div class="stacked-bar-chart">
        <div v-for="(standard, sIdx) in graphData" :key="standard.key" class="stacked-bar-row">
          <div class="stacked-bar-label">{{ standard.key }}</div>
          <div class="stacked-bar">
            <div
              v-for="(sub, idx) in standard.substandards"
              :key="sub.label"
              class="stacked-bar-segment"
              :style="segmentStyle(sub, standard.substandards.length)"
              :class="{ complete: sub.completed, incomplete: !sub.completed }"
              :id="'macp-segment-' + standard.key + '-' + idx"
            >
              <b-tooltip :target="'macp-segment-' + standard.key + '-' + idx" placement="top">
                {{ sub.tooltip || sub.label }}
              </b-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import Pulse from "./loaders/Pulse";
import { BTooltip } from 'bootstrap-vue';
export default {
  name: "StackedBarChartWidget",
  components: { Pulse, BTooltip },
  props: {
    title: { type: String, required: true },
    graphData: { type: Array, required: true },
    loading: { type: Boolean, default: false },
  },
  methods: {
    segmentStyle(sub, total) {
      return {
        width: (100 / total) + '%',
        backgroundColor: sub.completed ? '#4CAF50' : '#EF5350',
        cursor: 'pointer',
      };
    },
  },
};
</script>

<style scoped>
.stacked-bar-chart-widget {
  padding: 16px 0;
}
.stacked-bar-row {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
}
.stacked-bar-label {
  width: 100px;
  font-weight: 600;
}
.stacked-bar {
  display: flex;
  flex: 1;
  height: 32px;
  border-radius: 0;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04);
  background: #f5f5f5;
}
.stacked-bar-segment {
  height: 100%;
  transition: background 0.2s;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #fff;
  font-weight: 500;
  border-right: 1px solid rgba(0,0,0,0.07);
}
.stacked-bar-segment:last-child {
  border-right: none;
}
.stacked-bar-segment.complete {
  background: #4CAF50;
}
.stacked-bar-segment.incomplete {
  background: #EF5350;
}
.stacked-bar-segment:hover {
  opacity: 0.85;
}
</style>
